import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { ComponentSync, TS_VirtualizedList } from '@nu-art/thunderstorm-frontend/index';
class VirtualizedElements extends ComponentSync {
    deriveStateFromProps(nextProps) {
        return;
    }
    random_bg_color() {
        const x = Math.floor(Math.random() * 256);
        const y = Math.floor(Math.random() * 256);
        const z = Math.floor(Math.random() * 256);
        return 'rgb(' + x + ',' + y + ',' + z + ')';
    }
    generateRandomElements() {
        const elementsArray = [];
        for (let i = 0; i < 2000000; i++) {
            elementsArray.push(_jsx("div", { style: {
                    background: this.random_bg_color(),
                    height: Math.floor(Math.random() * (800 - 200 + 1)) + 200 + 'px',
                    width: Math.floor(Math.random() * (800 - 200 + 1)) + 200 + 'px'
                }, children: `element ${i}` }));
        }
        return elementsArray;
    }
    render() {
        return _jsx(_Fragment, { children: _jsx(TS_VirtualizedList, { itemHeight: 100, className: 'custom-scrollbar__vertical', listToRender: this.generateRandomElements() }) });
    }
}
export const PgDev_VirtualizedElements = {
    name: 'Virtualized Elements',
    key: 'virtualized-elements',
    renderer: VirtualizedElements
};
